import type { CreateHolidayRequest, HolidayResponse } from '$lib/api/types';

export type HolidayFormValues = {
	name: string;
	date: string;
	recurring: boolean;
};

type ValidationResult =
	| { ok: true; request: CreateHolidayRequest }
	| { ok: false; message: string };

const DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
const MAX_NAME_LENGTH = 100;

export function validateHolidayForm(
	values: HolidayFormValues,
	existingHolidays: Pick<HolidayResponse, 'date'>[]
): ValidationResult {
	const name = values.name.trim();
	if (!name) {
		return { ok: false, message: '공휴일 이름을 입력해주세요.' };
	}
	if (name.length > MAX_NAME_LENGTH) {
		return { ok: false, message: '공휴일 이름은 100자 이하로 입력해주세요.' };
	}

	if (!isValidDateString(values.date)) {
		return { ok: false, message: '공휴일 날짜를 올바르게 입력해주세요.' };
	}

	if (existingHolidays.some((holiday) => holiday.date === values.date)) {
		return { ok: false, message: '이미 등록된 공휴일 날짜입니다.' };
	}

	return {
		ok: true,
		request: {
			name,
			date: values.date,
			recurring: values.recurring
		}
	};
}

function isValidDateString(value: string): boolean {
	if (!DATE_PATTERN.test(value)) return false;
	const [year, month, day] = value.split('-').map(Number);
	const date = new Date(year, month - 1, day);
	return (
		date.getFullYear() === year &&
		date.getMonth() === month - 1 &&
		date.getDate() === day
	);
}
